/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 관리자페이지 NavBar
 * 버전 : 1.0
 * 파일명 : AdNavBar.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================ 
 * 수정일 : 2025-12-26, 강동형 : 일반 관리자 계정 조건부 렌더링
 * 수정일 : 2026-02-02, 강동형 : 새로고침시 userInfo값 비어있지 않도록 변경
 * ================================================================  */

import MainLogo from 'src/assets/images/Army_Link.svg'
import Icon_Admin from 'src/assets/images/Icon_Admin.svg'
import LogoutIcon from '@mui/icons-material/Logout';
import { useLocation, useNavigate } from 'react-router-dom';
import PersonIcon from '@mui/icons-material/Person';
import DescriptionIcon from '@mui/icons-material/Description';
import AdsClickIcon from '@mui/icons-material/AdsClick';
import Icon_Calendar from 'src/assets/images/Icon_Calendar.svg'
import Icon_Group from 'src/assets/images/Icon_Group.svg'
import { postLogout } from 'src/api/Auth';
import { useAdLoginStore } from 'src/stores/AdLoginStore';
import { useStorageStore } from 'src/stores/StorageStore';
import styled from "styled-components";

const TopWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    background-color: #fff;
    box-shadow: 0px 3px 4px 0px rgba(0, 0, 20, 0.1);
    height: 76px;
    width: 100%;
    position: fixed;
    z-index: 1;
`;

const TopButtonWarpper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    margin-right: 40px;
`;

const TopButtonContainer = styled.button<{ $isAdmin?: boolean }>`
    all: unset;

    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;

    white-space: nowrap;
    cursor: pointer;

    pointer-events: ${({ $isAdmin }) => ($isAdmin ? "auto" : "none")};
`;

const LeftWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    gap: 20px;

    position: fixed;
    width: 320px;
    left: 0;
    top: 76px;

    background-color: white;
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);
    height: 100%;
    padding: 50px 20px;
`;

const LeftButtonWrapper = styled.button<{ $isActive: boolean }>`
    all: unset;

    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 15px;

    width: 100%;
    box-sizing: border-box;
    border-radius: 5px;

    background-color: ${({ $isActive }) => ($isActive ? "#508A9C" : "white")};
    color: ${({ $isActive }) => ($isActive ? "white" : "black")};

    font-size: 18px;
    padding: 18px 20px;
    cursor: pointer;
`;

const TopImgWrapper = styled.button`
    all: unset;

    display: flex;
    justify-content: center;
    align-items: center;

    cursor: pointer;
`;


const AdNavBar = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const storage = useStorageStore()
    const isExactAdminPage = location.pathname === '/admin';
    const isActive = location.pathname
    const setField = useAdLoginStore((state)=>state.setField)
    const userInfo = storage.getItem('user')?.data
    const logout = async()=>{
        await postLogout();
        const preserveKeys = ["savedId","savingId"]
        for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && !preserveKeys.includes(key)) {
            localStorage.removeItem(key);
            i--; // 삭제하면 length가 줄어들기 때문에 보정
        }
        }       
        for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i);
        if (key && !preserveKeys.includes(key)) {
            sessionStorage.removeItem(key);
            i--; // 보정
        }
        }
        navigate('/admin'); // 로그인 페이지로 이동
    }

    const onClickLogo = ()=>{
        if(isExactAdminPage){
            setField('tab','Login')
        }
        else{
            navigate('/admin/account')
        }
    }
    
    return (
        <>
            <TopWrapper>
                <TopImgWrapper>
                    <img src={MainLogo} onClick={onClickLogo} style={{width:'247px',height:'auto'}}/>
                </TopImgWrapper>
                <TopButtonWarpper>
                    {!isExactAdminPage &&(
                        <>
                        <TopButtonContainer $isAdmin={true} onClick={()=>navigate('/admin/userinfo')}>
                            {userInfo?.user_type === 'admin' ?  '관리자' : userInfo?.team_name ?? '팀 미지정'}
                            <img src={Icon_Admin}/>
                        </TopButtonContainer>
                        <TopButtonContainer $isAdmin={true} onClick={logout}>
                            로그아웃
                            <LogoutIcon sx={{padding:'3px'}}/>
                        </TopButtonContainer>
                        </>)}
                </TopButtonWarpper>
            </TopWrapper>
            {!isExactAdminPage &&(
            <>
            <LeftWrapper>
                <LeftButtonWrapper $isActive={isActive === '/admin/achive'} onClick={()=>navigate('/admin/achive')}><AdsClickIcon/>홍보 성과 분석</LeftButtonWrapper>
                {userInfo?.user_type === 'admin' ?
                <>
                <LeftButtonWrapper $isActive={isActive === '/admin/team'} onClick={()=>navigate('/admin/team')}><img src={Icon_Group} style={{filter : isActive !== '/admin/team' ? 'invert(100%) brightness(1000%)' : 'none', width:'24px',height:'24px'}}/>팀 관리</LeftButtonWrapper>
                <LeftButtonWrapper $isActive={isActive === '/admin/promo'} onClick={()=>navigate('/admin/promo')}><DescriptionIcon/>홍보 결과 관리</LeftButtonWrapper>
                <LeftButtonWrapper $isActive={isActive === '/admin/recruit'} onClick={()=>navigate('/admin/recruit')}><img src={Icon_Calendar} style={{filter : isActive === '/admin/recruit' ? 'invert(100%) brightness(1000%)' : 'none'}}/> 모집 일정 관리</LeftButtonWrapper>
                <LeftButtonWrapper $isActive={isActive === '/admin/account'} onClick={()=>navigate('/admin/account')}><PersonIcon/>홍보관 계정 관리</LeftButtonWrapper>
                </> 
                : 
                <></>
                }
            </LeftWrapper>
            </>)}
        </>
    )
}

export default AdNavBar